import ModelSelector from './src/main';

/* istanbul ignore next */
ModelSelector.install = function(Vue) {
  Vue.component(ModelSelector.name, ModelSelector);
};

export default ModelSelector;
